function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.91 11.724a.887.887 0 01-1.287 0 .965.965 0 010-1.331L10.902 7H.909C.407 7 0 6.52 0 6s.407-1 .909-1h9.977L6.623 1.607a.965.965 0 010-1.332.887.887 0 011.286.001l5.824 5.059a.964.964 0 010 1.33L7.91 11.724z",
  fill: "#7B8B99",
  fillRule: "evenodd"
});

var SvgRightArrow = function SvgRightArrow(props) {
  return React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12"
  }, props), _ref);
};

export default SvgRightArrow;